import React, { useState } from "react";
import { useLanguage } from "../contexts/LanguageContext";
import EndOfServiceTool from "../components/tools/EndOfServiceTool";
import DemandLetterTool from "../components/tools/DemandLetterTool";
import { LEGAL_TOOLS_ROADMAP } from "../tools/constants/toolRoadmap";
import "./ToolsPage.css";

const ToolsPage = () => {
  const { isRTL, t } = useLanguage();
  const [activeTool, setActiveTool] = useState("end-of-service");

  return (
    <div className={`tools-page ${isRTL ? "rtl" : "ltr"}`}>
      <div className="tools-container">
        <header className="tools-header">
          <h1>{t("tools.page.title")}</h1>
          <p>{t("tools.page.subtitle")}</p>
        </header>

        <div className="tools-switcher" role="tablist" aria-label={t("tools.page.switcherAriaLabel")}>
          <button
            type="button"
            role="tab"
            aria-selected={activeTool === "end-of-service"}
            className={`tools-switch-btn ${activeTool === "end-of-service" ? "active" : ""}`}
            onClick={() => setActiveTool("end-of-service")}
          >
            {t("tools.eos.title")}
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={activeTool === "demand-letter"}
            className={`tools-switch-btn ${activeTool === "demand-letter" ? "active" : ""}`}
            onClick={() => setActiveTool("demand-letter")}
          >
            {t("tools.demand.title")}
          </button>
        </div>

        {activeTool === "end-of-service" ? <EndOfServiceTool /> : <DemandLetterTool />}

        <aside className="tools-roadmap-note">
          <h3>{t("tools.roadmap.title")}</h3>
          <ul>
            {LEGAL_TOOLS_ROADMAP.preparedFeatures.map((item) => (
              <li key={item}>{t(`tools.roadmap.feature.${item}`)}</li>
            ))}
          </ul>
        </aside>
      </div>
    </div>
  );
};

export default ToolsPage;

